import React from 'react';
import type { DividerProps as BaseDividerProps } from 'antd';

import { Divider } from './styled.ts';
export type { BaseDividerProps };

export const BaseDivider: React.FC<BaseDividerProps> = ({ className, ...props }) => (
    <Divider className={className} {...props} />
);
